import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  onChangeType,
  onTouchType,
} from 'src/app/core/models/common/custom.component.model';
import { IMAGE_SRC } from '../../../shared-constants';

@Component({
  selector: 'app-form-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
  ],
})
export class DatePickerComponent implements ControlValueAccessor, OnInit {
  @Input() minDate!: Date;
  @Input() maxDate!: Date;
  @Input() value!: Date;
  @Input() required = false;
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() icon = IMAGE_SRC.ENABLED_CALENDAR;
  @Input() readOnly = true;
  @Input() isSuffixIcon = false;
  @Input() width: string | number = '';
  @Input() customClass = '';

  @Output() valueChange = new EventEmitter<Date>();

  onChange: onChangeType = () => {};
  onTouch: onTouchType = () => {};
  date!: Date;
  disabledIcon = IMAGE_SRC.DISABLED_CALENDAR;

  ngOnInit(): void {
    this.writeValue(this.value);
  }

  registerOnChange(fn: onChangeType): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: onTouchType): void {
    this.onTouch = fn;
  }

  writeValue(value: Date) {
    this.date = value;
  }

  onModelChange(e: Date) {
    this.date = e;
    this.onChange(e);
    this.writeValue(e);
    this.valueChange.emit(e);
  }

  getWidthClass(): string {
    const widthValue = String(this.width ?? '').trim();
    if (!widthValue) {
      return '';
    }

    const widthClassMap: Record<string, string> = {
      '126': 'date-picker-width-126',
      '127': 'date-picker-width-127',
      '160': 'date-picker-width-160',
      '180': 'date-picker-width-180',
    };

    return widthClassMap[widthValue] ?? '';
  }
}
